import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=5245f130&scoped=true"
import script from "./bar.vue?vue&type=script&lang=js"
export * from "./bar.vue?vue&type=script&lang=js"
import style0 from "./bar.vue?vue&type=style&index=0&id=5245f130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245f130",
  null
  
)

export default component.exports